module.exports = __webpack_public_path__ + "img/emo_43.3b45fcaa.png";